import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import UpgradePricingBuilder from '../components/Pricing/UpgradePricingBuilder'

export default function Pricing() {
  const [tab, setTab] = useState('gp')

  return (
    <div className="pricing-public-page">
      <nav className="landing-navbar">
        <div className="landing-nav-left">
          <Link to="/" className="landing-nav-logo">
            Rotation<span>Street</span>
          </Link>
          <span className="landing-nav-tagline">Global GP/LP Connectivity</span>
        </div>
        <ul className="landing-nav-links">
          <li>
            <Link to="/">Home</Link>
          </li>
          <li>
            <Link to="/signup?role=GP">For GP</Link>
          </li>
          <li>
            <Link to="/signup?role=LP">For LP</Link>
          </li>
          <li>
            <Link to="/pricing" className="active">
              Pricing
            </Link>
          </li>
        </ul>
        <div className="landing-nav-right">
          <Link to="/login" className="landing-btn landing-btn-outline landing-btn-sm">
            Log In
          </Link>
          <Link to="/signup" className="landing-btn landing-btn-primary landing-btn-sm">
            Get Started
          </Link>
        </div>
      </nav>

      <div className="pricing-public-header">
        <h1>Pricing</h1>
        <p>Transparent plans for GPs and LPs — pay only for what you need</p>
      </div>

      <div className="pricing-tab-nav">
        <button
          type="button"
          className={`pricing-tab-btn${tab === 'gp' ? ' active' : ''}`}
          onClick={() => setTab('gp')}
        >
          GP Pricing
        </button>
        <button
          type="button"
          className={`pricing-tab-btn${tab === 'lp' ? ' active' : ''}`}
          onClick={() => setTab('lp')}
        >
          LP Pricing
        </button>
      </div>

      <div className="pricing-public-body">
        <UpgradePricingBuilder role={tab === 'gp' ? 'GP' : 'LP'} demoAllowed={false} />
        <p style={{ textAlign: 'center', marginTop: 24, fontSize: 14, color: '#909399' }}>
          Already have an account?{' '}
          <Link to="/login" style={{ color: '#1a5fd1', fontWeight: 600 }}>
            Log in
          </Link>{' '}
          to complete checkout, or{' '}
          <Link to="/signup" style={{ color: '#1a5fd1', fontWeight: 600 }}>
            sign up
          </Link>{' '}
          to get started.
        </p>
      </div>
    </div>
  )
}
